import axios, { AxiosError } from "axios";

export const handleError = (
  error: unknown,
  message: string = "Erro desconhecido.",
  success: boolean = false,
  context: string = "Ocorreu um erro."
): { message: string; success: boolean } => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<any>;

    if (axiosError.response) {
      const status = axiosError.response.status;
      const responseData = axiosError.response.data;

      if (status >= 400 && status < 500) {
        message =
          responseData?.message ||
          "Erro na requisição do cliente, inválida ou não autorizada";
        success = false;
      } else if (status >= 500 && status < 600) {
        message =
          responseData?.message ||
          "Erro interno no servidor, inválida ou não autorizada.";
        success = false;
      } else {
        message = responseData?.message || axiosError.message || message;
        success = responseData?.success ?? success;
      }
    } else {
      message = axiosError.message || message;
    }

    console.error(`${context} Erro na requisição:`, message);
  } else {
    console.error(`${context} Erro inesperado:`, error);
  }

  return { message, success };
};
